import { Box, Grid, styled, Typography, useTheme } from "@mui/material"
import Image from "next/image"
import { FC, useState } from "react"

interface LandingCardProps {
  id: number
  title: string
  logo: string
  onSelectMerchant: (id) => void
}

const LandingCard: FC<LandingCardProps> = ({ id, title, logo, onSelectMerchant }) => {
  const theme = useTheme()
  let fallbackSrc = "/images/no-photo.svg"
  const [imgSrc, setImgSrc] = useState(logo)

  const onError = () => {
    setImgSrc(fallbackSrc)
  }

  const StyledGrid = styled(Grid)(({ theme }) => ({
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    "&:hover": {
      boxShadow: theme.shadows[3],
      borderRadius: 3
    }
  }))

  const ImageWrapper = styled(Box)({
    cursor: "pointer",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "rotate(360deg)"
    }
  })
  return (
    <>
      <StyledGrid item xs={6} sm={6} md={4}>
        <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' py={1}>
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            width={80}
            height={80}
            borderRadius='50%'
            bgcolor={theme.palette.grey[100]}
            position='relative'
          >
            <ImageWrapper onClick={() => onSelectMerchant(id)}>
              <Image alt={title} src={imgSrc} onError={onError} width={45} height={45} />
            </ImageWrapper>
          </Box>
          <Typography
            fontSize={12}
            fontWeight={600}
            p={1}
            sx={{ cursor: "pointer" }}
            onClick={() => onSelectMerchant(id)}
          >
            {title}
          </Typography>
        </Box>
      </StyledGrid>
    </>
  )
}

export default LandingCard
